// extracted by mini-css-extract-plugin
export default {"rowSpace":"Home_rowSpace__cMEte","cardLeft":"Home_cardLeft__yjsQM","cardRight":"Home_cardRight__+8CCO","mdTitle":"Home_mdTitle__ckqrE"};